@if (breadcrumbs()) {
  <ol
    class="breadcrumbs"
    aria-label="breadcrumbs"
    [attr.data-testid]="TestIds.Breadcrumbs"
  >
    <li class="item">
      <a
        class="link"
        routerLink="/"
        matTooltip="Dashboard"
      >
        <mat-icon class="icon">home</mat-icon>
      </a>
    </li>
    @for (breadcrumb of breadcrumbs(); track breadcrumb.uuid; let last = $last) {
      <li
        class="item"
        [class.closed]="breadcrumb.isEntityClosed"
      >
        @if (breadcrumb.entityNumber) {
          <procure-entity-badge
            [clickable]="entityClickable()"
            [linked]="entityClickable()"
            [label]="breadcrumb.entityNumber"
            [tooltip]="breadcrumb.displayName"
          />
        }
        @if (!last && !breadcrumb.entityNumber) {
          <a
            class="link"
            [routerLink]="splitUrl(breadcrumb.url)"
            [queryParams]="queryParams(breadcrumb.url)"
          >
            <span class="label">
              {{ breadcrumb.displayName }}
            </span>
          </a>
        }
        @if (last) {
          <span class="label">
            <b>{{ breadcrumb.displayName }}</b>
          </span>
          @if (breadcrumb.entityNumber && breadcrumb.displayName) {
            <procure-copy-button
              class="copy"
              tooltip="Copy entity name"
              [value]="breadcrumb.displayName"
            />
          }
          <procure-copy-button
            class="copy"
            tooltip="Copy link"
            isUrl
            [value]="breadcrumb.url"
          />
          @if (sapAribaLink()) {
            <a
              class="external"
              target="_blank"
              rel="noopener noreferrer"
              [href]="sapAribaLink()"
            >
              <img
                class="icon-link"
                alt="SAP Ariba"
                matTooltip="Open SAP Ariba"
                [src]="'/assets/images/sap-ariba.png' | fileHash"
              />
            </a>
          }
          @if (orbisLink()) {
            <a
              class="external"
              target="_blank"
              rel="noopener noreferrer"
              [href]="orbisLink()"
            >
              <img
                class="icon-link"
                alt="ORBIS"
                matTooltip="Open ORBIS"
                [src]="'/assets/images/orbis.png' | fileHash"
              />
            </a>
          }
          @if (sncrpLink()) {
            <a
              class="external sncrp"
              target="_blank"
              rel="noopener noreferrer"
              matTooltip="Open SNCRP"
              [href]="sncrpLink()"
            >
              SNCRP
            </a>
          }
          @if (gravityLink()) {
            <a
              class="external"
              target="_blank"
              rel="noopener noreferrer"
              [href]="gravityLink()"
            >
              <img
                class="icon-link"
                alt="GRAVITY"
                matTooltip="Open Gravity Search"
                [src]="'/assets/images/gravity.png' | fileHash"
              />
            </a>
          }
          @if (xapienLink()) {
            <a
              class="external"
              target="_blank"
              rel="noopener noreferrer"
              [href]="xapienLink()"
            >
              <img
                class="icon-link"
                alt="Xapien"
                matTooltip="Open Xapien"
                [src]="'/assets/images/xapien.svg' | fileHash"
              />
            </a>
          }
          @if (ecoVadisLink()) {
            <a
              class="external"
              target="_blank"
              rel="noopener noreferrer"
              [href]="ecoVadisLink()"
            >
              <img
                class="icon-link"
                alt="EcoVadis"
                matTooltip="Open EcoVadis"
                [src]="'/assets/images/ecovadis.svg' | fileHash"
              />
            </a>
          }
          @if (externalLink()) {
            <a
              class="external"
              target="_blank"
              rel="noopener noreferrer"
              matTooltip="Open in new tab"
              [href]="externalLink()"
            >
              <mat-icon class="external-icon">open_in_new</mat-icon>
            </a>
          }
        }
      </li>
    }
  </ol>
}
